/**
 * Test venues for live D365 rehearsals (RSM1–RSM8), one request workbook each
 * (`pnpm --filter @lg/web build:test-requests`). Synthetic: venue names, addresses
 * and staff are fictional. Each venue has its own five people, so positions
 * (RSMn-GM…), personnel numbers (RSMn001…), UPNs and derived D365 user IDs never
 * collide across the files, or with the seeded V-companies.
 */
export interface TestVenue {
  companyId: string;
  city: string;
  venueType: 'Stadium' | 'Arena' | 'Convention center' | 'Other';
  street: string;
  state: string;
  zip: string;
  timeZone: string;
  /** Venue financial dimension value; also the search name stem. */
  code: string;
  /** Five staff in slot order: GM, finance manager, buyer, AP clerk, project manager. */
  staff: ReadonlyArray<readonly [first: string, last: string]>;
}

export const TEST_VENUES: readonly TestVenue[] = [
  {
    companyId: 'RSM1',
    city: 'Chicago',
    venueType: 'Arena',
    street: '100 Lakefront Way',
    state: 'IL',
    zip: '60601',
    timeZone: 'America/Chicago',
    code: 'CHICAGO',
    staff: [
      ['Aria', 'Kowal'],
      ['Ben', 'Okoro'],
      ['Cleo', 'Varga'],
      ['Dev', 'Sandhu'],
      ['Elle', 'Marchetti'],
    ],
  },
  {
    companyId: 'RSM2',
    city: 'Dallas',
    venueType: 'Stadium',
    street: '200 Trinity Boulevard',
    state: 'TX',
    zip: '75201',
    timeZone: 'America/Chicago',
    code: 'DALLAS',
    staff: [
      ['Finn', 'Alvarado'],
      ['Gia', 'Thorne'],
      ['Hugo', 'Brandt'],
      ['Iris', 'Nakamura'],
      ['Jace', 'Whitfield'],
    ],
  },
  {
    companyId: 'RSM3',
    city: 'New York City',
    venueType: 'Arena',
    street: '300 West Pier Avenue',
    state: 'NY',
    zip: '10001',
    timeZone: 'America/New_York',
    code: 'NYC',
    staff: [
      ['Kira', 'Lindgren'],
      ['Leo', 'Castellano'],
      ['Mina', 'Farouk'],
      ['Nico', 'Pryor'],
      ['Opal', 'Hensley'],
    ],
  },
  {
    companyId: 'RSM4',
    city: 'Tampa',
    venueType: 'Stadium',
    street: '400 Channelside Drive',
    state: 'FL',
    zip: '33602',
    timeZone: 'America/New_York',
    code: 'TAMPA',
    staff: [
      ['Pia', 'Delgado'],
      ['Quin', 'Mercer'],
      ['Rhea', 'Bannister'],
      ['Sol', 'Ferreira'],
      ['Tess', 'Galloway'],
    ],
  },
  {
    companyId: 'RSM5',
    city: 'San Francisco',
    venueType: 'Convention center',
    street: '500 Embarcadero Way',
    state: 'CA',
    zip: '94105',
    timeZone: 'America/Los_Angeles',
    code: 'SANFRANCISCO',
    staff: [
      ['Uri', 'Lockhart'],
      ['Vera', 'Szabo'],
      ['Wes', 'Kimura'],
      ['Xia', 'Romero'],
      ['Yuri', 'Bellamy'],
    ],
  },
  {
    companyId: 'RSM6',
    city: 'San Jose',
    venueType: 'Arena',
    street: '600 Guadalupe Parkway',
    state: 'CA',
    zip: '95110',
    timeZone: 'America/Los_Angeles',
    code: 'SANJOSE',
    staff: [
      ['Zane', 'Holloway'],
      ['Ada', 'Pemberton'],
      ['Bram', 'Ishikawa'],
      ['Cora', 'Valdez'],
      ['Dax', 'Moreland'],
    ],
  },
  {
    companyId: 'RSM7',
    city: 'Boston',
    venueType: 'Arena',
    street: '700 Harborfront Avenue',
    state: 'MA',
    zip: '02210',
    timeZone: 'America/New_York',
    code: 'BOSTON',
    staff: [
      ['Ezra', 'Quinlan'],
      ['Faye', 'Montrose'],
      ['Gideon', 'Asante'],
      ['Hana', 'Brennick'],
      ['Ivo', 'Calder'],
    ],
  },
  {
    companyId: 'RSM8',
    city: 'Seattle',
    venueType: 'Stadium',
    street: '800 Elliott Bay Way',
    state: 'WA',
    zip: '98121',
    timeZone: 'America/Los_Angeles',
    code: 'SEATTLE',
    staff: [
      ['Juno', 'Halvorsen'],
      ['Knox', 'Strand'],
      ['Lila', 'Oyelaran'],
      ['Milo', 'Sorensen'],
      ['Nadia', 'Okonkwo'],
    ],
  },
];
